<template>
  <div>
    <b-tooltip position="is-left" :label="$t('admin.exportImport')">
      <div @click="isImpExp = true">
        <img
          style="width:25px;height:25px;margin-right:15px;;cursor:pointer;"
          src="~@/assets/img/icons/duplicate.png"
          alt="share-icon"
        />
      </div>
    </b-tooltip>
    <!-- modal pour l'import / export -->
    <b-modal style="margin-top:20px;" :width="780" :active.sync="isImpExp">
      <AdminResultsIndividuelsPopupImportExport
        :insight_id="this.insight_en_cours.id"
      />
    </b-modal>
  </div>
</template>

<script>
import AdminResultsIndividuelsPopupImportExport from "@/components/popup/AdminResultsIndividuelsPopupImportExport";
import { mapGetters } from "vuex";

export default {
  components: {
    AdminResultsIndividuelsPopupImportExport,
  },
  data() {
    return {
      AdminResultsIndividuelsPopupImportExport,
      isImpExp: false,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  computed: {
    ...mapGetters(["insight_en_cours"]),
  },
};
</script>